import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFire2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="fire-2, flame, hot, heat"><path d="M19.75 13.3311C19.75 17.7046 16.2802 21.25 12 21.25C7.71979 21.25 4.25 17.7046 4.25 13.3311C4.25 11.2548 5.28333 8.40278 7.35 6.34722L8.9 7.88889L12.5167 2.75C12.5167 2.75 19.75 6.86111 19.75 13.3311Z" stroke="currentColor" strokeWidth="1.5"/><path d="M15 17.8256C15 19.7169 13.6569 21.25 12 21.25C10.3431 21.25 9 19.7169 9 17.8256C9 15.0278 12 13.25 12 13.25C12 13.25 15 15.0278 15 17.8256Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconFire2;
